const UserRoles = {
  superuser: 'superuser',
  admin: 'administrator',
  adminWithSecurity: 'administrator_security',
  security: 'security',
  owner: 'owner',
};

export default UserRoles;
